// Import of actions
import * as ServiceMessageActions from "../actions/service-message.actions";
import { IDiaprofilServiceMessage } from "../../models/types";

export type ServiceMessageState = IDiaprofilServiceMessage[];

export const initialState: IDiaprofilServiceMessage[] = [];

export function serviceMessagesReducer(
  state = initialState,
  action: ServiceMessageActions.Actions
): ServiceMessageState {
  switch (action.type) {
    case ServiceMessageActions.RESET_STATE: {
      return initialState;
    }

    case ServiceMessageActions.ADD: {
      return state.find(item => item.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case ServiceMessageActions.REPLACE: {
      return [
        ...state.filter(item => item.id !== action.payload.id),
        action.payload // payload is FHIR resource
      ];
    }

    case ServiceMessageActions.UPDATE: {
      return state.map(item => {
        return item.id === action.payload.id
          ? { ...item, ...action.payload }
          : item;
      });
    }

    case ServiceMessageActions.DELETE: {
      return state.filter(item => item.id !== action.payload.id);
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/service-message.reducer.ts